export default __webpack_public_path__ + "static/media/img_avatar.5184a2e2.png";